import { REDUCE_ENTITY } from '../../constants/actions/policy';

export function reduceEntity(payload) {
    return {
        type: REDUCE_ENTITY,
        payload,
    };
}
